<template>
	<div>
		<AppTooltip text="Show visibility settings">
			<AnemicButton @click="$emit('show-full-menu')" tile v-if="numAndNounOfSharedUsersAndGroups" class="indication-container px-2">
				Already shared with {{ numAndNounOfSharedUsersAndGroups }}
			</AnemicButton>
		</AppTooltip>
	</div>
</template>
<script>
import { pluralize } from '@/utils/language-service';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { workflowSharedData } from '@/store/modules/workflows/getters';
export default {
	name: 'PreviouslySharedWithIndicator',
	props: { workflowId: { type: Number } },
	computed: {
		...mapGettersShorthand({ workflowSharedData }),
		sharedWorkflowData() {
			return this.workflowSharedData(this.workflowId) || {};
		},
		numOfSharedUsers() {
			return (this.sharedWorkflowData.shared_users?.length || 1) - 1; // should always contain 'me'
		},
		numOfSharedGroups() {
			return this.sharedWorkflowData.shared_groups?.length || 0;
		},
		numOfGroupsText() {
			return this.pluralizeIfNeeded('group', this.numOfSharedGroups);
		},
		numOfUsersText() {
			return this.pluralizeIfNeeded('user', this.numOfSharedUsers);
		},
		numAndNounOfSharedUsersAndGroups() {
			const sentenceDivider = this.numOfSharedGroups === 0 || this.numOfSharedUsers === 0 ? '' : ' and ';
			return `${this.numOfUsersText}${sentenceDivider}${this.numOfGroupsText}`;
		},
	},
	methods: {
		pluralizeIfNeeded(noun, number) {
			return number > 0 ? pluralize(noun, number, true) : '';
		},
	},
};
</script>
<style scoped lang="scss">
.indication-container {
	height: 23px !important;
	font-size: 12px !important;
	color: #8d96a2 !important;
	font-weight: 400 !important;
	border-radius: 5px !important;
	letter-spacing: 0px !important;
	text-transform: none !important;
	background: #fbfbfd !important;
	border: 1px solid #d6ddea !important;
}
</style>
